import React, { memo, useCallback } from 'react'
import { ThemeProvider, useMediaQuery, useTheme } from '@material-ui/core'
import PropTypes from 'prop-types'
import { getWhiteTheme } from '@v4/utils/theme'
import { MEDIA_POSITION } from '@v4/components/sections/Question/Question.const'
import useQuestionSettingsField from '@v4/hooks/questions/useQuestionSettingsField'
import QuestionsBuilderSelector from '@v4/utils/selectors/QuestionsBuilderSelector'
import useQuestionField from '@v4/hooks/questions/useQuestionField'
import useQuestionId from '@v4/hooks/questions/useQuestionId'

const WhiteThemeProvider = ({ children, enabled = true }) => {
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
	const desktopPosition = useQuestionSettingsField('desktop_position')
	const mobilePosition = useQuestionSettingsField('mobile_position')
	const invertColors = useQuestionSettingsField('invert_colors')
	const position = isMobile ? mobilePosition : desktopPosition
	const questionId = useQuestionId()
	const gallery = QuestionsBuilderSelector.useGallery()
	const asset = useQuestionField(questionId, 'asset')
	const isQuestionGallery = gallery?.entityId === questionId && gallery?.entityType === 'question'
	const previewPath = isQuestionGallery ? gallery.preview?.path : null
	const showMedia = !!previewPath || !!asset?.path
	const withBgAsset = MEDIA_POSITION.BACKGROUND === position && showMedia

	const allowWhite = invertColors && withBgAsset && enabled

	const whiteTheme = useCallback(
		parentTheme => {
			return allowWhite ? getWhiteTheme(parentTheme) : parentTheme
		},
		[allowWhite],
	)

	return <ThemeProvider theme={whiteTheme}>{children}</ThemeProvider>
}

WhiteThemeProvider.propTypes = {
	enabled: PropTypes.bool,
	children: PropTypes.node.isRequired,
}

export default memo(WhiteThemeProvider)
